import React from 'react';
import { CalendarDays, CreditCard, Crown, FileText, IndianRupee, MessageCircle, PackageOpen, Receipt, Store, UsersRound, Wallet, Boxes } from 'lucide-react';
import styles from './Marquee.module.css';

const ITEMS = [
    [Wallet, 'Collect cash in advance'], [UsersRound, 'Bring clients back'], [CalendarDays, 'Fill empty chairs'], [Receipt, 'Brand every bill'],
    [Crown, 'Upsell at the counter'], [MessageCircle, 'Win back lost clients'], [PackageOpen, 'Lock in future visits'], [IndianRupee, 'Get paid by UPI'],
    [CreditCard, 'Sell prepaid cards'], [Store, 'Grow to more branches'], [FileText, 'Know your numbers daily'], [Boxes, 'Never run out of stock'],
];

/** Endless strip of capabilities (pauses on hover; static when reduced motion is on) */
export default function Marquee() {
    const row = ITEMS.map(([Icon, label]) => (
        <span className={styles.item} key={label}><Icon size={14} strokeWidth={2.2} /> {label}</span>
    ));
    return (
        <div className={styles.wrap} aria-label="How Hirsta grows your salon">
            <div className={styles.track}>
                <div className={styles.group}>{row}</div>
                <div className={styles.group} aria-hidden="true">{row}</div>
            </div>
        </div>
    );
}
